module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.lAction === 'view') ? _c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      }
    }, [_vm._v("\n      " + _vm._s(tabitem) + "\n    ")])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-container', {
    staticClass: "pa-2",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab-item', {
      key: n,
      attrs: {
        "value": ("tab-" + n)
      }
    }, [_c('v-layout', [(_vm.tab === 'tab-0') ? _c('v-flex', {
      staticClass: "mx-auto",
      attrs: {
        "xs12": "",
        "offset-sm3": ""
      }
    }, [_c('v-card', [_c('v-card-title', {
      staticClass: "pa-2 grey lighten-4"
    }, [_c('div', {
      staticClass: "title grey--text"
    }, [_vm._v("Registered vendors")])]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pa-0"
    }, [_c('v-data-table', {
      attrs: {
        "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.vendorHeadSm : _vm.vendorHead,
        "items": _vm.vendors,
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', {
            on: {
              "click": function($event) {
                return _vm.prepareUpdateVendor(props.item)
              }
            }
          }, [_c('td', [_vm._v(_vm._s(props.item.vendor_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contact_phone))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.contact_email))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.contact_name))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.gst_no))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.vendor_status))]) : _vm._e()])]
        }
      }], null, true)
    })], 1)], 1)], 1) : _c('v-flex', {
      staticClass: "mx-auto",
      attrs: {
        "xs12": "",
        "offset-sm3": ""
      }
    }, [_c('v-card', [_c('v-card-title', {
      staticClass: "pa-2 grey lighten-4"
    }, [_c('div', {
      staticClass: "title grey--text"
    }, [_vm._v("Non-residents")])]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pa-0"
    }, [_c('v-data-table', {
      attrs: {
        "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.nonResHeadSm : _vm.nonResHead,
        "items": _vm.nonResList,
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', {
            on: {
              "click": function($event) {
                return _vm.prepareUpdateNonRes(props.item)
              }
            }
          }, [_c('td', [_vm._v(_vm._s(props.item.non_res_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contact_phone))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.contact_email))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.non_res_descrip))]) : _vm._e()])]
        }
      }], null, true)
    })], 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab === 'tab-0' ? _vm.prepareCreateVendor() : _vm.prepareCreateNonRes()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), (_vm.tab === 'tab-0') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; left:15px;' : 'bottom:15px; left:315px;')),
    attrs: {
      "small": "",
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareUpload($event)
      }
    }
  }, [_c('v-icon', [_vm._v("file_upload")])], 1) : _vm._e()], 2)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'create-nonres' || _vm.lAction === 'update-nonres') ? _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "nForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChangesNonRes(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n            " + _vm._s(_vm.handy.startWithUpper(_vm.lAction.substring(0, _vm.lAction.indexOf('-')))) + " Non-resident\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Non-resident name",
      "maxlength": "50",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lNonRes.non_res_name),
      callback: function($$v) {
        _vm.$set(_vm.lNonRes, "non_res_name", $$v)
      },
      expression: "lNonRes.non_res_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Phone",
      "hide-details": "",
      "type": "number",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lNonRes.contact_phone),
      callback: function($$v) {
        _vm.$set(_vm.lNonRes, "contact_phone", $$v)
      },
      expression: "lNonRes.contact_phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Service description",
      "hide-details": "",
      "rules": [_vm.rules.required],
      "rows": "2"
    },
    model: {
      value: (_vm.lNonRes.service_desc),
      callback: function($$v) {
        _vm.$set(_vm.lNonRes, "service_desc", $$v)
      },
      expression: "lNonRes.service_desc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text subheader pa-0"
  }, [_vm._v("Other Information (Optional)")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-Mail",
      "maxlength": "50",
      "hide-details": ""
    },
    model: {
      value: (_vm.lNonRes.contact_email),
      callback: function($$v) {
        _vm.$set(_vm.lNonRes, "contact_email", $$v)
      },
      expression: "lNonRes.contact_email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Address",
      "maxlength": "150",
      "hide-details": ""
    },
    model: {
      value: (_vm.lNonRes.address),
      callback: function($$v) {
        _vm.$set(_vm.lNonRes, "address", $$v)
      },
      expression: "lNonRes.address"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "City",
      "maxlength": "25",
      "hide-details": ""
    },
    model: {
      value: (_vm.lNonRes.city),
      callback: function($$v) {
        _vm.$set(_vm.lNonRes, "city", $$v)
      },
      expression: "lNonRes.city"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "PIN",
      "maxlength": "10",
      "hide-details": ""
    },
    model: {
      value: (_vm.lNonRes.pin),
      callback: function($$v) {
        _vm.$set(_vm.lNonRes, "pin", $$v)
      },
      expression: "lNonRes.pin"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update-nonres') ? _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.deleteNonRes($event)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'create-vendor' || _vm.lAction === 'update-vendor') ? _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "vForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChangesVendor(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n            " + _vm._s(_vm.handy.startWithUpper(_vm.lAction.substring(0, _vm.lAction.indexOf('-')))) + " Vendor\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lAction === 'update-vendor') ? _c('v-text-field', {
    attrs: {
      "label": "Vendor name",
      "maxlength": "50",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lVendor.vendor_name),
      callback: function($$v) {
        _vm.$set(_vm.lVendor, "vendor_name", $$v)
      },
      expression: "lVendor.vendor_name"
    }
  }) : _c('v-combobox', {
    attrs: {
      "label": "Vendor name",
      "items": _vm.globalVendors,
      "item-value": "vendor_id",
      "item-text": "vendor_name",
      "maxlength": "50",
      "clearable": "",
      "hint": "Choose from common list or enter new if not found",
      "persistent-hint": ""
    },
    on: {
      "input": _vm.loadChosenVendor
    },
    model: {
      value: (_vm.lVendor.vendor),
      callback: function($$v) {
        _vm.$set(_vm.lVendor, "vendor", $$v)
      },
      expression: "lVendor.vendor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text subheader pa-0"
  }, [_vm._v("Other Information (Optional)")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Phone",
      "hide-details": "",
      "type": "number"
    },
    model: {
      value: (_vm.lVendor.contact_phone),
      callback: function($$v) {
        _vm.$set(_vm.lVendor, "contact_phone", $$v)
      },
      expression: "lVendor.contact_phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "EMail",
      "maxlength": "50",
      "hide-details": ""
    },
    model: {
      value: (_vm.lVendor.contact_email),
      callback: function($$v) {
        _vm.$set(_vm.lVendor, "contact_email", $$v)
      },
      expression: "lVendor.contact_email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Contact person",
      "maxlength": "50",
      "hide-details": ""
    },
    model: {
      value: (_vm.lVendor.contact_name),
      callback: function($$v) {
        _vm.$set(_vm.lVendor, "contact_name", $$v)
      },
      expression: "lVendor.contact_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Designation",
      "maxlength": "50",
      "hide-details": ""
    },
    model: {
      value: (_vm.lVendor.contact_desig),
      callback: function($$v) {
        _vm.$set(_vm.lVendor, "contact_desig", $$v)
      },
      expression: "lVendor.contact_desig"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Address",
      "maxlength": "150",
      "hide-details": ""
    },
    model: {
      value: (_vm.lVendor.address),
      callback: function($$v) {
        _vm.$set(_vm.lVendor, "address", $$v)
      },
      expression: "lVendor.address"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "City",
      "maxlength": "25",
      "hide-details": ""
    },
    model: {
      value: (_vm.lVendor.city),
      callback: function($$v) {
        _vm.$set(_vm.lVendor, "city", $$v)
      },
      expression: "lVendor.city"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "PIN",
      "maxlength": "10",
      "hide-details": ""
    },
    model: {
      value: (_vm.lVendor.pin_code),
      callback: function($$v) {
        _vm.$set(_vm.lVendor, "pin_code", $$v)
      },
      expression: "lVendor.pin_code"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "GST Number",
      "maxlength": "15",
      "hide-details": ""
    },
    model: {
      value: (_vm.lVendor.gst_no),
      callback: function($$v) {
        _vm.$set(_vm.lVendor, "gst_no", $$v)
      },
      expression: "lVendor.gst_no"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgVendorDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lVendor.vendor_since
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lVendor, "vendor_since", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lVendor, "vendor_since", $event)
      }
    },
    model: {
      value: (_vm.dlgVendorDt),
      callback: function($$v) {
        _vm.dlgVendorDt = $$v
      },
      expression: "dlgVendorDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "hide-details": "",
      "label": "Vendor since",
      "append-icon": "event",
      "readonly": "",
      "clearable": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lVendor.vendor_since),
      callback: function($$v) {
        _vm.$set(_vm.lVendor, "vendor_since", $$v)
      },
      expression: "lVendor.vendor_since"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lVendor.vendor_since),
      callback: function($$v) {
        _vm.$set(_vm.lVendor, "vendor_since", $$v)
      },
      expression: "lVendor.vendor_since"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgVendorDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgVendorDt.save(_vm.lVendor.vendor_since)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update-vendor') ? _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.deleteVendor($event)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'upload') ? _c('v-container', {
    staticClass: "pa-2",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pa-0 pl-3"
  }, [_vm._v("\n          Upload Vendor List\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 text-xs-center primary--text",
    staticStyle: {
      "font-family": "'Satisfy', cursive",
      "font-size": "200%",
      "font-weight": "normal"
    }
  }, [_vm._v("In just 4 steps")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 1")]), _vm._v(" "), _c('span', [_vm._v("Download template")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('form', {
    attrs: {
      "method": "get",
      "action": "../static/files/Smartility_Vendor_List_Template.xlsx"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0",
    attrs: {
      "type": "submit",
      "small": ""
    }
  }, [_c('v-icon', [_vm._v("file_download")])], 1)], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 2")]), _vm._v(" "), _c('span', [_vm._v("Fill-in details as guided in template")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 3")]), _vm._v(" "), _c('span', [_vm._v("Save as CSV "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(Comma delimited)")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "caption grey--text pl-4 ml-4"
  }, [_c('span', {
    staticClass: "ml-4"
  }, [_vm._v("Go with OK/Yes when prompted while saving")])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 4")]), _vm._v(" "), _c('span', [_vm._v("Upload the CSV file")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0 accent",
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.promptUpload($event)
      }
    }
  }, [_c('v-icon', [_vm._v("file_upload")])], 1)], 1), _vm._v(" "), _c('input', {
    ref: "ipFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": function($event) {
        return _vm.validateFile()
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "mt-3 text-xs-center primary--text",
    staticStyle: {
      "font-family": "'Satisfy', cursive",
      "font-size": "200%",
      "font-weight": "normal"
    }
  }, [_vm._v("Uniservice takes care of rest")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 5")]), _vm._v(" "), _c('span', [_vm._v("Validate your information")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 6")]), _vm._v(" "), _c('span', [_vm._v("Create Vendor List")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0 pr-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'validate') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pa-0 pl-3"
  }, [_vm._v("\n          Upload Vendor List\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-center pl-2 pr-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "mx-auto": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "info--text mb-2",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.validateInProgress) ? _c('span', [_vm._v("Loading and validating the file...")]) : _vm._e(), _vm._v(" "), (_vm.validFile && !_vm.validateInProgress) ? _c('span', [_vm._v("File validation is successfull "), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile) ? _c('span', [_vm._v("File validation is failed "), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile && _vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("Invalid column headers, please ensure names and count are matching as per the template")]) : _vm._e(), _vm._v(" "), (!_vm.validFile && !_vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more invalid records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e(), _vm._v(" "), (!_vm.totFail && !_vm.loadInProgress) ? _c('span', [_vm._v("Vendor list upload was successfull"), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("Vendor list upload has failed"), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("Vendor list upload partially failed"), _c('v-icon', {
    staticClass: "warning--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totFail && !_vm.loadInProgress) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more failed records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e()]), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "info",
      "value": _vm.readyForLoad ? 100 : (_vm.recsLoaded.length / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.readyForLoad ? _vm.totValid : _vm.recsLoaded.length) + "\n                ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Records")])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "success",
      "value": (_vm.totValid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                " + _vm._s(_vm.readyForLoad ? _vm.totLoaded : _vm.totValid) + "\n              ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Loaded' : 'Valid'))])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "error",
      "value": (_vm.totInvalid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n              " + _vm._s(_vm.readyForLoad ? _vm.totFail : _vm.totInvalid) + "\n            ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Failed' : 'Invalid'))])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lAction = 'upload'
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.totValid > 0) ? _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "small": "",
      "disabled": _vm.beingSaved
    },
    nativeOn: {
      "click": function($event) {
        return _vm.uploadVendor($event)
      }
    }
  }, [_vm._v("Process the valid records")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-3 text-xs-left",
    attrs: {
      "headers": _vm.loadHeadSm,
      "items": _vm.recsLoaded,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: (props.item.error ? (props.item.load_status === 'Failed' ? 'error' : 'error--text') : (props.item.load_status === 'Loaded' ? 'success' : '')),
          on: {
            "click": function($event) {
              props.item.error ? _vm.showError(props.item.error) : ''
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.vendor_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contact_phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contact_email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contact_person))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contact_desig))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.city))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.pin_code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.gst_no))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.vendor_since))])])]
      }
    }], null, false, 1358607610)
  })], 1)], 1)], 1), _vm._v(" "), (false) ? _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])]), _vm._v(" "), (_vm.load) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "20%",
      "left": "50%"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ebea280","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vendor.vue
// module id = 804
// module chunks = 13